import { RefreshCw } from 'lucide-react';
import './MaintenancePage.css';

export function MaintenancePage({ maintenance = {}, busy = false, onRetry }) {
  return <main className="maintenance-page">
    <section className="maintenance-card">
      <img src="./branding/the-dope-man-logo.webp" alt="The Dope Man" />
      <span className="maintenance-kicker">TEMPORARILY OFF THE CORNER</span>
      <h1>{maintenance.title || 'The Dope Man is temporarily off the corner.'}</h1>
      <p>{maintenance.message || 'Somebody is moving furniture around in the back room. Try again shortly.'}</p>
      {maintenance.reason && <small>{maintenance.reason}</small>}
      <button onClick={onRetry} disabled={busy}><RefreshCw />{busy ? ' CHECKING…' : ' CHECK AGAIN'}</button>
      <em>Your stash is still where you left it. Probably.</em>
    </section>
  </main>;
}
